<template>
  <section class="content_container plan_confirm">
    <div class="thank_you">
      <!-- <div class="img text-center thank-img-container">
        <img :src="thankYouImage ? thankYouImage : defaultImage" alt="Corenroll">
      </div> -->
      <div class="content mt-2">
        <!-- <h1>
          <span class="head_grey">Thank you for choosing our</span><br>Insurance Plans.
        </h1> -->
        <div class="eligibility-container mb-4 eligibility-effective-date d-flex ">
          <div class="icon-wrapper d-flex align-items-center justify-content-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20 20"><path fill="currentColor" d="M5.673 0a.7.7 0 0 1 .7.7v1.309h7.517v-1.3a.7.7 0 0 1 1.4 0v1.3H18a2 2 0 0 1 2 1.999v13.993A2 2 0 0 1 18 20H2a2 2 0 0 1-2-1.999V4.008a2 2 0 0 1 2-1.999h2.973V.699a.7.7 0 0 1 .7-.699M1.4 7.742v10.259a.6.6 0 0 0 .6.6h16a.6.6 0 0 0 .6-.6V7.756zm5.267 6.877v1.666H5v-1.666zm4.166 0v1.666H9.167v-1.666zm4.167 0v1.666h-1.667v-1.666zm-8.333-3.977v1.666H5v-1.666zm4.166 0v1.666H9.167v-1.666zm4.167 0v1.666h-1.667v-1.666zM4.973 3.408H2a.6.6 0 0 0-.6.6v2.335l17.2.014V4.008a.6.6 0 0 0-.6-.6h-2.71v.929a.7.7 0 0 1-1.4 0v-.929H6.373v.92a.7.7 0 0 1-1.4 0z"/></svg>
          </div>
          <div class="content-wrap">
            <h6 class=" content-title">Effective Date</h6>
            <div class="eligibility-text">Your coverage will begin on <span class="fw-semibold text-bold">{{effective}}</span></div>
          </div>
        </div>
        <!--        <div class="eligibility-container mb-2 mt-2">
                  <div class="content-wrap">
                    <h6 class="content-title mb-2">Eligibility Requirement</h6>
                    <div class="eligibility-text"><span>Please confirm whether each individual being enrolled is either a <strong> U.S. citizen</strong> or <strong>a green card holder.</strong></span></div>
                  </div>

                </div>-->
        <div class="enrollment-method mt-3">

          <h6 class="main-label-title mb-2">Choose Enrollment Method</h6>

          <div class="eligibility-checkboxs mb-3">

            <div class="checkbox-option"
                 @click="selectEnrollmentMethod('standard')"
                 :class="{ 'active-option': enrollmentMethod === 'standard' }">
              <input
                  type="radio"
                  id="standardEnroll"
                  value="standard"
                  v-model="enrollmentMethod"
              >
              <label for="standardEnroll" class="eligibility-label m-0">
                Standard Enrollment
              </label>
            </div>

            <div class="checkbox-option"
                 @click="selectEnrollmentMethod('single')"
                 :class="{ 'active-option': enrollmentMethod === 'single' }">
              <input
                  type="radio"
                  id="singlePageEnroll"
                  value="single"
                  v-model="enrollmentMethod"
              >
              <label for="singlePageEnroll" class="eligibility-label m-0">
                Single Page Enrollment
              </label>
            </div>

          </div>

        </div>
        <div v-if="eligibilityConfirmed === 'no'" class="mb-3 error-message">
          <span v-if="eligibilityConfirmed === 'no'"><i class="fa fa-exclamation-circle"></i></span>
          Enrollment is only available to U.S. citizens or permanent residents.
        </div>
        <div v-if="isFromAetnaEnroll" class="text-center">
          <button class="univ-btn"  :disabled="eligibilityConfirmed !== 'yes'"  :class="{ 'disabled-btn': eligibilityConfirmed !== 'yes' }"
                  style="background: #006cb0;" @click="nextPage">Proceed to Enrollment</button>
        </div>
        <div class="proceed-btn text-center mt-4 mb-2 pt-1 d-flex align-items-center justify-content-center gap-3" v-else>
          <button class="back  m-0" type="button" id="backCart" name="button" @click="navigatePrevious">Back to Cart</button>
          <button class="proceed m-0" type="button" id="beginEnroll" name="button" @click="nextPage"
                  :disabled="!enrollmentMethod">Continue to Enroll</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// import axios from 'axios';
import {commonModuleUrl} from "../config/config";
export default {
  name: "EligibilityConfirmation",
  props: {
    effective: Array,
    athenaEffectiveDate: String,
    isFromAetnaEnroll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      eligibilityConfirmed: null,
      tempId: window.localStorage.getItem('tempId'),
      thankYouImage: 'https://corenroll-logo.s3.us-east-2.amazonaws.com/enrollment-complete-bg.png',
      defaultImage: '',
      enrollmentMethod: 'single'
    }
  },
  computed: {
    landingInfo() {
      return this.$store.getters.getLandingInfo
    },
    getLandingUrl () {
      return this.$store?.getters?.getLandingUrl
    }
  },
  mounted() {
    let app = this;
    app.tempId = window.localStorage.getItem('tempId');
    app.fetchCatchInfo();
  },
  methods: {
    proceedToSinglePageEnrollment () {
      this.$emit('Checkoutcart',1);
      const currentDomain = window.location.hostname || 'goenroll123.com';
      window.open(`${commonModuleUrl}/enrollments/${this.tempId}/${currentDomain}`, '_self')
    },
    selectEnrollmentMethod (value) {
      this.enrollmentMethod = value;
    },
    nextPage: function() {
      if (this.enrollmentMethod === 'single') {
        this.proceedToSinglePageEnrollment();
      } else {
        this.$emit('Checkoutcart');
        localStorage.setItem('enrollment', 'new_enrollment');
        if (this.getLandingUrl) {
          this.$router.push(`/${this.getLandingUrl}/enrollment/personal-info`)
        } else {
          this.$router.push('enrollment/personal-info');
        }
      }
    },
    navigatePrevious: function() {
      this.$emit('hidePopUp');
    },
    fetchCatchInfo() {
      let siteDomain = window.btoa(unescape(encodeURIComponent(process.env.VUE_APP_SITE_DOMAIN)))
      // let siteDomain = 'aHR0cHM6Ly9lbnJvbGwucHVyZW5yb2xsLmNvbQ=='
      let url = `${process.env.VUE_APP_API_BASE}/get-external-site-dynamic-information?site_domain=${siteDomain}`
      caches.open('fetch_color_cache').then((cache) => {
        cache.match(url).then(response => {
          response.json().then(data => {
            let getCatchColor = []
            let newObj = {}
            getCatchColor = data
            getCatchColor.map(item => {
              newObj[item.key] = item.value;
            });
            this.defaultImage = newObj["VUE_APP_THANK_YOU"]
          })
        })
      }).catch((err) => {
        console.log(err);
      })
    },
  }
}
</script>

<style src="../assets/css/confirm_eligibility.css">
</style>